import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Certification } from '@queries/generated';
import { AnalyticsEventType } from '@services/analytics-events.service';

@Component({
  selector: 'vnm-verifiable-credentials',
  templateUrl: './verifiable-credentials.component.html',
  styleUrls: ['./verifiable-credentials.component.scss']
})
export class VerifiableCredentialsComponent implements OnChanges {
  @Input() certification!: Certification;
  @Input() showMessage = true;
  @Input() showHeader = false;
  @Input() eventType: AnalyticsEventType;

  verifiedCredential: boolean | null = null;
  walletStatus = '';
  // when the certification is the user's own and they haven't set it up yet
  drawAttention: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.certification) {
      this.verifiedCredential = this.certification.verifiedCredentialExported;
      this.walletStatus = `verifiable-credentials.credential-status.${
        this.verifiedCredential ? 'added-to-wallet' : 'not-added-to-wallet'
      }`;
      this.drawAttention = !this.verifiedCredential && this.certification.can.shareToSocial;
    }
  }
}
